<template>
  <div>
    <topbar
      :titulo="editandoMatricula ? 'Editar Matrícula' : $t('ACADEMICO_MATRICULAS.NOVA_MATRICULA')"
      :subtitulo="$t('ACADEMICO_MATRICULAS.MATRICULA_PAGE_DESCRICAO_NOVO')"
      :breadcrumbs="breadcrumbs"
    >
      <template #header>
        <b-button
          variant="secondary"
          class="mr-2"
          @click="voltar"
        >
          {{ $t('GERAL.VOLTAR') }}
        </b-button>
      </template>
    </topbar>
    <b-tabs v-model="tabIndex">
      <b-tab :title="`1 - ${$t('GERAL.DADOS_GERAIS')}`" class="pt-2">
        <formulario-dados-gerais ref="formularioDadosGeraisRef" :form="form" :listaInstituicoesDeEnsino="listaInstituicoesDeEnsino"/>
      </b-tab>

      <b-tab :title="`2 - ${$t('FICHA_SAUDE.FICHA_SAUDE')}`" class="pt-2">
        <formulario-ficha-saude ref="fichaSaudeRef" :fichaSaude="form.fichaSaude" />
        <b-row>
          <b-col cols="12" class="text-right">
            <b-button variant="primary" @click="salvar">
              {{ $t('GERAL.SALVAR') }}
            </b-button>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <tabs-btns :tabIndex="tabIndex" :ultimaTab="1" @alterar-tab="alterarTab" />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Services:
import MatriculaService from '@/common/services/matriculas/matriculas.service';
import FichaSaudeService from '@/common/services/ficha-saude/ficha-saude.service';

// Models:
import { Matricula } from '@/common/models';

// Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import FormularioDadosGerais from '@/views/academico/matriculas/components/FormularioDadosGerais.vue';
import FormularioFichaSaude from '@/views/academico/matriculas/components/FormularioFichaSaude.vue';
import TabsBtns from '@/components/btns/TabsBtns';
import InstituicaoEnsinoService from '@/common/services/instituicao-ensino/instituicao-ensino';

export default {
  components: {
    Topbar,
    FormularioDadosGerais,
    FormularioFichaSaude,
    TabsBtns,
  },
  data() {
    return {
      id: this.$route.params.id,
      tabIndex: 0,
      form: new Matricula({
        pessoaId: this.$route.params.idPessoa,
        nome: this.$route?.query?.nome,
      }),
      pessoasVinculos: [],
      pessoasDadosAluno: [],
      opcoes: {
        periodoLetivo: [],
      },
      modais: {
        vinculos: false,
        vinculosDados: {},
      },
      loadingPessoas: false,
      listaInstituicoesDeEnsino: [],
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO_MATRICULAS.MATRICULAS') },
        { titulo: this.$t('ACADEMICO_MATRICULAS.NOVA_MATRICULA') },
      ],
    };
  },
  mounted() {
    if (this.id) this.buscar();
    else this.buscarListInstituicoes();
  },
  computed: {
    editandoMatricula() {
      return !!this.$route.params.id
    }
  },
  methods: {
    alterarTab(tab) {
      this.tabIndex = tab;
    },

    buscar() {
      this.$store.dispatch(START_LOADING);

      MatriculaService.buscarPorId(this.id)
        .then(async ({ data }) => {
          this.form = new Matricula(data);
          this.buscarListInstituicoes();
          this.buscarFichaSaude();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    async buscarListInstituicoes() {
      await InstituicaoEnsinoService.obterInstituicoesTodos().then(
        ({ data }) => {
          this.listaInstituicoesDeEnsino = data.map((row) => ({
            text: row.nome,
            value: row.id,
          }));

          this.form.escolaOrigemId = this.listaInstituicoesDeEnsino.find(i => i.value == this.form.escolaOrigemId)
        }
      );
    },

    buscarFichaSaude() {
      this.$store.dispatch(START_LOADING);
      FichaSaudeService.buscarPorMatriculaId(this.id)
        .then((res) => {
          this.form.atualizarFichaSaude(res.data ?? {})
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // FUNÇÕES: CRUD:
    validarSeExisteResponsavelFinanceiro() {
      return this.form.vinculos.some(
        (vinculo) =>
          vinculo.tipoResponsavel === 188 || vinculo.tipoResponsavel === 469
      );
    },
    validarResponsavelFinanceiroComCPF() {
      return this.form.vinculos.some(
        (vinculo) =>
          (vinculo.tipoResponsavel === 188 ||
            vinculo.tipoResponsavel === 469) &&
          vinculo.cpf
      );
    },
    validarFormulario() {
      if (!this.$refs.formularioDadosGeraisRef.validarFormulario())
        return false;
      if (!this.$refs.fichaSaudeRef.validarFormulario()) return false;
      if (!this.validarSeExisteResponsavelFinanceiro()) {
        mensagem.warning(
          'Deve haver pelo menos um responsável com a resposabilidade financeira'
        );
        return false;
      }
      if (!this.validarResponsavelFinanceiroComCPF()) {
        mensagem.warning('Responsável financeiro deve ter CPF');
        return false;
      }
      return true;
    },

    salvar() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);

      MatriculaService.salvar(this.form.payload)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('ACADEMICO_MATRICULAS.MENSAGEM_CADASTRADO')
          );
          this.voltar();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    voltar() {
      this.$router.push({
        name: 'matriculas'
      })
    },
  },
};
</script>
